<template>
  <div id="auth">
    <div class="container">
      <div class="sys_title">{{ sys_title }}</div>
      <div class="content">
        <a-row type="flex" align="middle">
          <a-col flex="480px">
            <img class="p2" src="../../assets/p2.png"/>
            <div class="m_text">
              <img src="../../assets/logo3.svg"/>
              <p>专家管理系统</p>
            </div>
          </a-col>
          <a-col flex="auto" style="padding: 0 40px">
            <p class="text1">
              <img class="logo" src="../../assets/logo2.svg" style="display: block;margin: auto"/>
            </p>
            <div class="login">
              <a-form :form="form" @submit="onSubmit">
                <a-form-item>
                  <a-input size="large" placeholder="手机号码"
                           v-decorator="['mobile', {rules: [{ required: true, message: '请输入手机号', whitespace: true}]}]">
                    <a-icon slot="prefix" type="mobile"/>
                  </a-input>
                </a-form-item>
                <a-form-item>
                  <a-row :gutter="8">
                    <a-col :span="16">
                      <a-input size="large" placeholder="验证码"
                               v-decorator="['code', {rules: [{ required: true,message: '请输入验证码', whitespace: true}]}]">
                        <a-icon slot="prefix" type="mail"/>
                      </a-input>
                    </a-col>
                    <a-col :span="8">
                      <a-button @click="requestCode()" :disabled="disabled"
                                :class="btnText==='获取验证码' ? 'buggetyaz' : 'getyaz'"
                                class="captcha-button" size="large">{{ btnText }}
                      </a-button>
                    </a-col>
                  </a-row>
                </a-form-item>
                <a-form-item style="text-align: right">
                  <a-button :loading="logging" style="width: 100%;margin-top: 12px" size="large" htmlType="submit"
                            type="primary">登录
                  </a-button>

                  <a-button style="width: 100%;margin-top: 12px" size="large" @click="goToStorage()">申请入库
                    <a-icon type="arrow-right"/>
                  </a-button>
                </a-form-item>
              </a-form>
              <p style="font-size: 18px;text-align: center;top: 28px;position: relative">
                <a-icon style="transform: scaleX(-1);" type="phone"/>
                咨询电话：
                <b style="color: #1f76ff">{{ consult_telePhone }}</b>
              </p>
            </div>
            <!--          微信二维码-->
            <div class="ewm_box">
              <img class="p1" :src="qrcode" width="100px"/>
              <p>
                关注我司微信服务号 <br/>
                随时查看通知和请假
              </p>
            </div>

          </a-col>
        </a-row>

      </div>
      <div class="copyright">版权所有：{{ sys_title }}</div>
    </div>
  </div>
</template>

<script>
import { GetVerificationCodeByExpertLogin } from '@/views/login/api/LoginApi'
import { getSysTitle } from '@/utils/auth'
import { CONSULT_TELE_PHONE, NEXT_EDIT_BANK_MODAL } from '@/store/mutation-types'
import { GetContentResourceByKey } from '@/epp/sysContentMange/api/sysContentMangeApi'
import { ACTION_TYPE, EXPERT_QR_CODE } from '@/epp/sysContentMange/util/sysContentMangeUtil'

export default {
  data () {
    return {
      form: this.$form.createForm(this),
      rememberMe: false,
      logging: false,
      error: '',
      redirect: undefined,
      btnText: '获取验证码',
      disabled: false,
      sys_title: '',
      consult_telePhone: '',
      qrcode: ''
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created () {
    this.initData()
  },
  methods: {

    async initData () {
      const res = await getSysTitle()
      this.sys_title = res
      this.consult_telePhone = this.$ls.get(CONSULT_TELE_PHONE)
      //获取二维码
      this.qrcode = await GetContentResourceByKey(EXPERT_QR_CODE, ACTION_TYPE.system)
      this.$ls.set(NEXT_EDIT_BANK_MODAL, false)
    },
    async requestCode () {
      let mobile = this.form.getFieldValue('mobile')
      if (!mobile) {
        this.$warning({
          title: '请输入手机号！'
        })
        return
      }
      const that = this
      this.disabled = true
      this.btnText = '请稍候...'
      this.type = 'gray'
      try {
        let res = await GetVerificationCodeByExpertLogin(mobile)
        if (res.code !== 200) {
          that.$error({ title: '提示', content: res.msg })
          that.btnText = '获取验证码'
          that.disabled = false
          that.type = 'primary'
          return
        }
        that.$message.success(res.msg)
        setTimeout(() => {
          let seconds = 60
          that.btnText = seconds + 's后获取'
          let countdown = setInterval(() => {
            if (seconds > 0) {
              that.btnText = seconds + 's后获取'
              --seconds
            } else {
              that.btnText = '获取验证码'
              that.disabled = false
              that.type = 'primary'
              clearInterval(countdown)
            }
          }, 1000)
        }, 500)
      } catch (e) {
        that.error = e
      }
    },
    onSubmit (e) {
      const that = this
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        this.logging = true
        let data = {
          ...values
        }
        this.$store.dispatch('ExpertLogin', data).then(() => {
          that.logging = false
          that.$router.replace({ path: this.redirect || '/dashboard/workplace' })
        }).catch((error) => {
          that.logging = false
          that.error = error.message
        })
      })
    },
    goToStorage () {
      this.$router.push({ path: '/expert/applyfor' })
    }
  }
}
</script>

<style lang="less" scoped>
.captcha-button {
  width: 100%;
}

/deep/ .ant-btn-lg, /deep/ .ant-input-lg {
  height: 48px;
  font-size: 17px;
}

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background-position: center;
  background-image: url("../../assets/bg.png");

  .sys_title {
    color: white;
    font-weight: bold;
    font-size: 32px;
    text-align: center;
    margin-bottom: 20px;
    letter-spacing: 3px;
  }

  .copyright {
    color: white;
    position: absolute;
    bottom: 10px;
    font-size: 16px;
  }

  .content {
    background: #fff;
    width: 960px;
    //overflow: hidden;
    padding: 0;
    border-radius: 15px;
    box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.2);

    .ewm_box{
      position: absolute;
      padding: 16px 8px;
      background: #fff;
      right: -160px;
      top: -58px;
      text-align: center;
      border-radius: 12px;
      box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.2);
      p{
        margin: 0;
      }
    }

    .text1 {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 38px;
    }

    .m_text {
      display: none;
    }

    .top {
      .header {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .logo {
          height: 78px;
          margin-right: 8px;
        }

        .title {
          font-size: 28px;
          font-weight: 600;
          position: relative;
          color: #000;
          margin: 0;
        }
      }

      .desc {
        font-size: 18px;
        color: #8c8c8c;
        margin: 0;
      }
    }

    .login {
      //margin-top: 50px;

      .icon {
        font-size: 24px;
        color: rgba(0, 0, 0, 0.2);
        margin-left: 16px;
        vertical-align: middle;
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: #1890ff;
        }
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .container {
    height: 100vh;
    overflow: hidden;
    background: none;
    display: block;

    .sys_title {
      color: black;
    }

    .copyright {
      color: black;
      text-align: center;
      width: 100%;
    }

    .content {
      background: #fff;
      width: 100%;
      padding: 0;
      border-radius: 0;
      box-shadow: none;

      .text1 {
        display: none;
      }

      .m_text {
        position: absolute;
        display: block;
        top: 10vw;
        left: 0;
        right: 0;
        text-align: center;
        color: #fff;
        font-size: 4.267vw;

        img {
          margin-bottom: 3.200vw;
          width: 15vw;
        }
      }

      .logo {
        display: none !important;
      }

      .p2 {
        content: url("../../assets/p3.png");
        width: 100%;
      }

      .ant-row-flex {
        > .ant-col {
          width: 100% !important;
          flex: inherit !important;

          &:nth-child(2) {
            padding: 0 20px !important;
          }
        }
      }


      .login {
        margin-top: -50px;

        .icon {
          font-size: 24px;
          color: rgba(0, 0, 0, 0.2);
          margin-left: 16px;
          vertical-align: middle;
          cursor: pointer;
          transition: color 0.3s;

          &:hover {
            color: #1890ff;
          }
        }
      }
    }
  }
}
</style>
